var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsEnum, IsOptional, IsString, MaxLength } from 'class-validator';
import { PaginationQueryDto } from '../../../classes/common/request/pagination-query.dto';
import { AdminNoticeCategory } from '../../../enums/admin-notice/admin-notice-category.enum';
import { AdminNoticeStatus } from '../../../enums/admin-notice/admin-notice-status.enum';
import { PartialType } from '../../../utils';
export class GetManyAdminNoticesQueryDto extends PartialType(PaginationQueryDto) {
}
__decorate([
    IsEnum(AdminNoticeCategory),
    IsOptional(),
    __metadata("design:type", String)
], GetManyAdminNoticesQueryDto.prototype, "category", void 0);
__decorate([
    IsEnum(AdminNoticeStatus),
    IsOptional(),
    __metadata("design:type", String)
], GetManyAdminNoticesQueryDto.prototype, "status", void 0);
__decorate([
    IsString(),
    MaxLength(100),
    IsOptional(),
    __metadata("design:type", String)
], GetManyAdminNoticesQueryDto.prototype, "keyword", void 0);
